import API_BASE_URL from "../RestAPI";

const BASE = `${API_BASE_URL.replace(/\/$/, "")}/ticketing/notifications`;

const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");
    const headers = { "Content-Type": "application/json" };
    if (token) headers.Authorization = `Bearer ${token}`;
    return headers;
};

const query = (params) => {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));
    return new URLSearchParams(clean).toString();
};

export const sprintNotificationsApi = {
    // { count, latest_id } — the call the sprint page makes every 60 s
    getUnreadCount: async (sprintId) => {
        const res = await fetch(`${BASE}/unread-count/?${query({ sprint_id: sprintId })}`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch notification count");
        return res.json();
    },

    // Unread rows newer than afterId, oldest first — shown as toasts
    getNewSince: async (sprintId, afterId) => {
        const res = await fetch(`${BASE}/?${query({ sprint_id: sprintId, after_id: afterId })}`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch new notifications");
        return res.json();
    },

    // History: { results, total, page, has_more }. params: page, page_size, unread, kind, search
    getList: async (sprintId, params = {}) => {
        const res = await fetch(`${BASE}/?${query({ sprint_id: sprintId, ...params })}`, { method: "GET", headers: getAuthHeaders() });
        if (!res.ok) throw new Error(res.statusText || "Failed to fetch notifications");
        return res.json();
    },

    markRead: async (id) => {
        const res = await fetch(`${BASE}/?id=${id}`, { method: "PUT", headers: getAuthHeaders() });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to mark notification as read");
        return data;
    },

    markAllRead: async (sprintId) => {
        const res = await fetch(`${BASE}/mark-all-read/?${query({ sprint_id: sprintId })}`, { method: "PUT", headers: getAuthHeaders() });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || "Failed to mark notifications as read");
        return data;
    },
};
